import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { ToastrModule } from 'ngx-toastr';

import { AppComponent } from "./app.component";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';

import { NgbModalModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { AppRoutingModule } from "./app-routing.module";
import { ComponentsModule } from "./components/components.module";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './pages/login/login.component';
import { ProxylistComponent } from './pages/proxylist/proxylist.component';
import { NgxPaginationModule } from "ngx-pagination";
import { LotteryComponent } from './pages/lottery/lottery.component';
import { LatestupdatesComponent } from './pages/latestupdates/latestupdates.component';
import { FacebooklinkComponent } from './pages/facebooklink/facebooklink.component';
import { LotteryOldComponent } from './pages/lottery-old/lottery-old.component';
import { CreateQuizComponent } from "./pages/createquiz/createquiz.component";
import { QuizReportComponent } from "./pages/quiz-report/quiz-report.component";

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    NgbModule,
    NgbModalModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AppRoutingModule,
    NgxPaginationModule,
    ToastrModule.forRoot()
  ],
  declarations: [AppComponent, AdminLayoutComponent, AuthLayoutComponent, LoginComponent, ProxylistComponent, CreateQuizComponent, LotteryComponent, LatestupdatesComponent, FacebooklinkComponent, LotteryOldComponent, QuizReportComponent],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
